import styled from "styled-components"
import { Link } from "gatsby"

const ApplyButton = styled(Link)`
  width: 151px;
  line-height: 46px;
  display: block;
  border: 0;

  font-family: var(--ff-secondary);
  font-size: 1em;
  font-weight: 700;
  letter-spacing: 0.0046em;

  color: #fff;
  transition: 0.2s ease-in-out;

  background-color: var(--clr-primary);
  cursor: pointer;
  text-transform: uppercase;
  text-decoration: none;

  text-align: center;
  align-items: center;

  @media (max-width: 64em) {
    max-width: 20.1875rem;
    width: 100%;
  }

  :hover {
    background-color: var(--clr-tertiary-bright);
    color: var(--clr-text-blue);
  }
`

export default ApplyButton
